import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ensureDefined } from '@e-socna/utils';

import { GenericAdminForm } from '../../../forms/GenericAdmin';
import { PATH_NOT_FOUND } from '../../../app/constants/paths.constant';
import type { GenericAdminFormValues } from '../../../forms/GenericAdmin';

import { RightDrawer } from '../../RightDrawer';
import { Admin as AdminCmp } from '../../Admin';

import { useDocumentEditorContext } from '../contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';
import type { Editable } from '../types/editable.type';

export const AdminTabPanel = () => {
  const {
    actions,
    props: {
      routerSettings: { editorModePaths },
    },
    state,
  } = useDocumentEditorContext<Editable>();

  const navigate = useNavigate();
  const { pathname: currentPath } = useLocation();

  const leaveEditionMode = useCallback(
    () => void navigate(editorModePaths.Admin ?? PATH_NOT_FOUND),
    [editorModePaths.Admin, navigate],
  );

  const handleSubmit = useCallback(
    (
      values: GenericAdminFormValues,
      _handleError: (error: unknown) => unknown,
      handleSuccess: () => unknown,
    ) => {
      actions.updateAdmin(values);
      leaveEditionMode();
      handleSuccess();
    },
    [actions, leaveEditionMode],
  );

  const { editable } = state;

  const { statusId } = ensureDefined({ statusId: editable.statusId });

  return (
    <>
      <AdminCmp
        createdAt={editable.createdAt}
        creatorId={editable.creatorId}
        id={editable._id}
        statusId={statusId}
        updatedAt={editable.updatedAt}
        updaterId={editable.updaterId}
      />
      <RightDrawer
        isOpen={currentPath === editorModePaths.AdminEdit}
        onDrawerClose={leaveEditionMode}
      >
        <GenericAdminForm
          askMemoBeforeSubmit={false}
          onCancel={leaveEditionMode}
          onSubmit={handleSubmit}
          statusId={statusId}
        />
      </RightDrawer>
    </>
  );
};
